import { makeStyles } from '@material-ui/core'
import React from 'react'
import type { HeaderProps } from 'react-big-calendar'
import { useCalendar } from '../CalendarContext'

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.typography.subtitle2,
    fontSize: '12px !important',
    textTransform: 'uppercase',
    color: theme.paintscout.palette.brand.Neutral.P50,
    display: 'flex',
    justifyContent: 'end',
    padding: theme.spacing(0.5, 1),
    fontWeight: 500
  }
}))

export default function MonthColumnHeader(props: HeaderProps) {
  const classes = useStyles()
  const { hideWeekends } = useCalendar()
  const { label, date } = props

  const isWeekend = date.getDay() === 0 || date.getDay() === 6

  if (isWeekend && hideWeekends) {
    return null
  }

  return <div className={classes.root}>{label}</div>
}
